import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-teal-600 to-teal-700 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* About Section */}
          <div>
            <h3 className="text-lg font-bold mb-4">About Me</h3>
            <p className="text-sm text-teal-50 leading-relaxed">
              釣り：淡水釣りから海水釣りまで、テクニック、道具のレビュー、魚の行動などを中心にカバー。
              アクアリウム：様々な種類の魚、水槽のメンテナンス、リラックスできる趣味としての水槽飼育の利点について学びます。
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">リンク</h3>
            <ul className="space-y-2">
              <li>
                <a
                  href="#home"
                  onClick={(e) => {
                    e.preventDefault();
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }}
                  className="text-gray-300 hover:text-white transition-colors duration-300 cursor-pointer"
                >
                  ホーム
                </a>
              </li>
              <li>
                <a
                  href="#blog"
                  onClick={(e) => {
                    e.preventDefault();
                    const element = document.getElementById('blog');
                    element?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="text-gray-300 hover:text-white transition-colors duration-300 cursor-pointer"
                >
                  ブログ
                </a>
              </li>
              <li>
                <a
                  href="#about"
                  onClick={(e) => {
                    e.preventDefault();
                    const element = document.getElementById('about');
                    element?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="text-gray-300 hover:text-white transition-colors duration-300 cursor-pointer"
                >
                  About
                </a>
              </li>
              <li>
                <Link
                  to="/privacy-policy"
                  className="text-gray-300 hover:text-white transition-colors duration-300"
                >
                  プライバシーポリシー
                </Link>
              </li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h3 className="text-lg font-bold mb-4">カテゴリー</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="#" className="text-teal-50 hover:text-white transition-colors duration-300">
                  釣り
                </a>
              </li>
              <li>
                <a href="#" className="text-teal-50 hover:text-white transition-colors duration-300">
                  AI
                </a>
              </li>
              <li>
                <a href="#" className="text-teal-50 hover:text-white transition-colors duration-300">
                  マーケティング
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-teal-500 mt-8 pt-8 text-center">
          <p className="text-sm text-teal-50">
            Copyright © 2024 アングリング・アクアティクス. All Rights Reserved. |{' '}
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white transition-colors duration-300"
            >
              Website Builder
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
